import api from "@/services/api";

export default {
  getAvailableOrganizations() {
    return api.get("/available-organizations");
  },

  switchOrganization(orgId) {
    return api.post("/switch-organization", { organization: orgId });
  },

  getOrganizations(params = {}) {
    return api.get("/organizations", { params });
  },

  getOrganization(id) {
    return api.get(`/organizations/${id}`);
  },

  createOrganization(data) {
    return api.post("/organizations", data);
  },

  updateOrganization(id, data) {
    return api.put(`/organizations/${id}`, data);
  },

  deleteOrganization(id) {
    return api.delete(`/organizations/${id}`);
  },

  getSettings() {
    return api.get("/organizations/setting");
  },

  updateSettings(data) {
    return api.post("/organizations/setting", data);
  },

  getUserOrganizations(userId) {
    return api.get(`/users/${userId}/organizations`);
  },

  changeAuthorizedOrganizations(userId, data) {
    return api.post(`/change-authorized-organizations/${userId}`, data);
  },
};
